module.exports = __webpack_public_path__ + "img/0Q3A7692_L_Black.da3dab25.jpg";